import { usePeriod } from "backend/model/usePeriod";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import Query from "qpr-base/querybuilder/Query";
import { useQuery } from "react-query";
import useTopElements from "../model/useTopElements";

type IResult = {
  id: string;
  name: string;
};

const useBySymbol = (symbol?: string) => {
  const ctx = useAppContext();
  const periods = usePeriod();
  const { data: topElements, isLoading: topElementsLoading } = useTopElements();

  return useQuery<IResult | null>(
    `data-by-symbol-${symbol}-${JSON.stringify(periods)}`,
    () => {
      if (symbol) {
        return Query(ctx.fullModelId)
          .BySymbol({ symbol })
          .fetchValues<IResult>()
          .then((list) => list[0]);
      }
      return null;
    },
    { enabled: !!symbol, cacheTime: 5 * 100, staleTime: 4 * 100 }
  );
};

export default useBySymbol;
